module.exports = __webpack_public_path__ + "static/img/record-person.ba4ac5bf.png";